import request from '@/utils/request'

const labelURL = {
  Created: '/label/create',
  List: '/label/list',
  ListArticle: '/label/list-article',
  LabelSearch: '/label/search',
  Detail: '/label/detail',
  Update: '/label/update',
  UpdateStu: '/label/update-status',
  Delete: '/label/delete'
}

// 创建标签
export function createLabel (data) {
  return request({
    url: labelURL.Created,
    method: 'post',
    data
  })
}

// 标签列表
export function listLabel (data) {
  return request({
    url: labelURL.List,
    method: 'post',
    data
  })
}

// 搜索标签列表
export function labelSearch (data) {
  return request({
    url: labelURL.LabelSearch,
    method: 'post',
    data
  })
}

// 标签列表（新）
export function listLabelArticle (data) {
  return request({
    url: labelURL.ListArticle,
    method: 'post',
    data
  })
}

// 标签详情
export function detailLabel (data) {
  return request({
    url: labelURL.Detail,
    method: 'post',
    data
  })
}

// 更新标签
export function updateArticleLabel (data) {
  return request({
    url: labelURL.Update,
    method: 'post',
    data
  })
}

// 更新标签状态
export function updateStatusLabel (data) {
  return request({
    url: labelURL.UpdateStu,
    method: 'post',
    data
  })
}

// 删除标签
export function deleteLabel (data) {
  return request({
    url: labelURL.Delete,
    method: 'post',
    data
  })
}

export default {
  listLabel,
  labelSearch,
  listLabelArticle,
  createLabel,
  detailLabel,
  updateArticleLabel,
  deleteLabel,
  updateStatusLabel
}
